import repoConfigs from '../../repoConfigs.json';
import { isRow3PGTargetHost } from './row-3pg-config';

// avoid inner domain check for argus
const postFix = 'bytedance';
const rootFix = 'net';
export const generateInnerDomain = (domain: string) => {
  // return domain.replace('{INNER_DOMAIN}', innerDomain);
  return domain.replace('{INNER', postFix).replace('_DOMAIN}', `.${rootFix}`);
};

// VisActor Domain
export const VisActorChineseDomains = [
  'www.visactor.com',
  'visactor.com',
  // for test
  'localhost',
];
export const isVisActorChineseDomain = (hostname: string) =>
  VisActorChineseDomains.includes(hostname);

export const VisActorOuterDomains = ['www.visactor.io', 'visactor.io'];
export const isVisActorOuterDomain = (hostname: string) =>
  VisActorOuterDomains.includes(hostname);

export const VisActorInnerDomains = [
  generateInnerDomain('visactor-site.gf.{INNER_DOMAIN}'),
  generateInnerDomain('visactor.{INNER_DOMAIN}'),
  'localhost',
];
export const isVisActorInnerDomain = (hostname: string) =>
  VisActorInnerDomains.includes(hostname);

// CDN Domain

// export const CDN_OUTER_CN = 'https://lf1-cdn-tos.bytescm.com/obj/static';
// export const CDN_OUTER_SG =
//   'https://sf16-scmcdn-sg.ibytedtos.com/obj/static-sg';
export const VisActorAffix = 'visactor-site';

export const getCDNDomain = () => {
  return __PUBLIC_PATH__.replace(/\/$/, '');
};

// Default Routes

export const visactorBlogDefaultRoute = 'datawind-visualization';
export const visactorSenarioDefaultRoute =
  'vscreen-visualization/datawind-vscreen';
export const visactorChartAssistantDefaultRoute =
  'https://charteasy.visactor.com/';

export const vchartDemoDefaultRoute = 'line-chart/basic-line';
export const vchartDemoReactDefaultRoute = 'usage/basic-line';
export const vchartDemoOpeninulaDefaultRoute = 'usage/basic-line';
export const vchartGuideDefaultRoute = 'tutorial_docs/VChart_Website_Guide';

export const vchartContributingDefaultRoute =
  '1-Setting-Up-the-Development-Environment';

export const vchartOptionDefaultRoute = 'barChart';
export const vchartAPIDefaultRoute = 'API/vchart';
export const vchartFAQDefaultRoute =
  '1--Does-the-tooltip-support-changing-the-background-color';
export const vchartThemeDefaultRoute = 'editor';
export const vchartChangelogDefaultRoute = 'release';

export const vtableDemoDefaultRoute = 'table-type/list-table';
export const vtableDemoReactDefaultRoute = 'usage/option';
export const vtableDemoVueDefaultRoute = 'usage/option';
export const vtableDemoOpeninulaDefaultRoute = 'usage/option';
export const vtableGuideDefaultRoute = 'Getting_Started/Getting_Started';
export const vtableContributingDefaultRoute =
  '1-Setting-Up-the-Development-Environment';
export const vtableOptionDefaultRoute = 'ListTable';
export const vtableAPIDefaultRoute = 'Methods';
export const vtableFAQDefaultRoute =
  '1-How to implement multi-level headers in a basic table';
export const vtableChangelogDefaultRoute = 'release';

export const vgrammarDemoDefaultRoute = 'basic-mark-rect/basic-rect';
export const vgrammarGuideDefaultRoute = 'guides/quick-start';
export const vgrammarOptionDefaultRoute = '';
export const vgrammarAPIDefaultRoute = 'API/View';
export const vgrammarChangelogDefaultRoute = 'changelog';

export const vrenderDemoDefaultRoute = 'graphic-arc/basic-arc';
export const vrenderGuideDefaultRoute = 'asd/VRender_Website_Guide';
export const vrenderOptionDefaultRoute = 'asd/VRender_Website_Guide';

export const vstoryGuideDefaultRoute = 'tutorial_docs/VStory_Website_Guide';

export const vgraphDemoDefaultRoute = 'solutions/dataLineage';
export const vgraphGuideDefaultRoute = 'start';
export const vgraphChangelogDefaultRoute = 'release';

export const vmindAPIDefaultRoute = 'VMind_Instance';
export const vmindGuideDefaultRoute = 'VMind_Website_Guide';
export const vmindScenarioDefaultRoute = 'Chart_Assistant';

// cache option & examples document for now
const isEnableCache = (url: string) => {
  const checkDocumentType =
    url.indexOf('option') > -1 || url.indexOf('examples') > -1;
  const checkRepoType =
    url.indexOf('vchart') > -1 || url.indexOf('vtable') > -1;
  return checkDocumentType && checkRepoType;
};
const fetchJsonCache: Map<string, any> = new Map();
const fetchTextCache: Map<string, any> = new Map();

const fetchResource = async (url: string) => {
  if (import.meta.env.SSR && isRow3PGTargetHost(url)) {
    const { fetchWithRow3PG } = await import('./row-3pg');
    return fetchWithRow3PG(url);
  }
  return fetch(url);
};

export const fetchJSON = async (url: string) => {
  if (url.startsWith('/')) {
    url = `${__PUBLIC_PATH__}${url.replace(/^\//, '')}`;
  }
  if (fetchJsonCache.has(url)) {
    return fetchJsonCache.get(url);
  }
  try {
    const response = await fetchResource(url);
    const json = await response.json();
    if (isEnableCache(url)) {
      fetchJsonCache.set(url, json);
    }
    return json;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const fetchText = async (url: string) => {
  if (url.startsWith('/')) {
    url = `${__PUBLIC_PATH__}${url.replace(/^\//, '')}`;
  }
  if (fetchTextCache.has(url)) {
    return fetchTextCache.get(url);
  }
  try {
    const response = await fetchResource(url);
    const text = await response.text();
    if (isEnableCache(url)) {
      fetchTextCache.set(url, text);
    }
    return text;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const fetchExamples = async (url: string) => {
  const menu = await fetchJSON(url);
  if (!menu) {
    return null;
  }
  const traverse = (
    menuItem: any,
    path: string = '',
    demos: any[] = [],
    rootGroup: string = ''
  ) => {
    const fullPath = path !== '' ? `${path}/${menuItem.path}` : menuItem.path;
    const currentRootGroup =
      rootGroup || (path === '' ? menuItem.path ?? '' : rootGroup);
    if (menuItem.children) {
      menuItem.children.forEach((childMenuItem: any) => {
        traverse(childMenuItem, fullPath, demos, currentRootGroup);
      });
    } else {
      // Some repos (e.g. VGraph) may emit non-object meta values in menu.json.
      // Normalize to an object so downstream pages can safely access meta.group.
      const meta =
        menuItem.meta && typeof menuItem.meta === 'object' ? menuItem.meta : {};
      // Fall back to the first-level path so sidebar groups can still render.
      if (!meta.group && currentRootGroup) {
        meta.group = currentRootGroup;
      }
      menuItem.meta = meta;
      menuItem.data = { fullPath };
      demos.push(menuItem);
    }
    return demos;
  };
  const data = traverse(menu);
  return data;
};

export const fetchDemo = async (
  demoUrl: string,
  exampleUrl: string,
  fullPath: string,
  search: string
) => {
  const keyword = search?.includes('?keyword=')
    ? search.split('?')[1].split('=')[1]
    : undefined;
  const [demo, examples] = await Promise.all([
    fetchText(demoUrl),
    fetchExamples(exampleUrl),
  ]);
  if (!demo || !examples) {
    return null;
  }
  const data = {
    meta: examples.find((example) => example.data.fullPath === fullPath)?.meta,
    content: demo,
  };
  const result = {
    data: data,
    navDemoData: examples ?? [],
    keyword: keyword,
  };
  return result;
};

export const getDocumentDirectory = (repo: string) => {
  const repoConfig =
    repoConfigs.find(
      (repoConfig) => repoConfig.repo.toLowerCase() === repo.toLowerCase()
    ) ?? repoConfigs[0];
  return `${__PUBLIC_PATH__}documents/${repoConfig.repo.toLowerCase()}-${
    repoConfig.version
  }`;
};

export const normalizeLoaderPath = (path: string) => {
  return path.replaceAll(' ', '-');
};
